import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IRoster } from './roster.models';

@Injectable()
export class RosterService {
    private _http = inject(HttpClient);

    public getRosterForGame(gameId: string): Observable<IRoster> {
        return this._http.get<IRoster>(`games/${gameId}/rosters?withpersons=true`);
    }
}
